/* eslint-disable @typescript-eslint/prefer-as-const */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var RightAlleyState = {
    None: "None",
    Filters: "Filters",
    GeoFilters: "GeoFilters",
};
export var MapViewRightAlleyState = __assign(__assign({}, RightAlleyState), { Placards: "Placards", Layers: "Layers" });
//# sourceMappingURL=types.js.map